import styled from 'styled-components';

import { colors, typography } from '../../styles/tokens';

export const Page = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

interface SectionProps {
  alt?: boolean;
}

// Ritmo/rima exatos do design de referência (`desing/TrenzoX Landing
// (1).html`): padding vertical fluido, divisor de 1px entre seções,
// e um alternar de fundo (`alt`) em Recursos/Preços.
export const Section = styled.section<SectionProps>`
  padding: clamp(64px, 7vw, 120px) clamp(20px, 5vw, 96px);
  border-top: 1px solid ${colors.borderSubtle};
  background: ${props => (props.alt ? colors.surfaceAlt : 'transparent')};
`;

export const SectionInner = styled.div`
  max-width: 1720px;
  margin: 0 auto;
`;

export const SectionHeading = styled.h2<{ maxWidth?: number }>`
  font-family: ${typography.displayFontFamily};
  font-weight: 800;
  font-size: clamp(30px, 3.6vw, 46px);
  line-height: 1.1;
  letter-spacing: -0.015em;
  margin: 0;
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}px` : 'none')};
  text-wrap: pretty;
  color: ${colors.textPrimary};
`;

export const SectionLead = styled.p<{ maxWidth?: number }>`
  font-size: 18px;
  line-height: 1.6;
  color: ${colors.textSecondary};
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}px` : '700px')};
  margin: 16px 0 46px;
`;

export const Eyebrow = styled.div`
  font-family: ${typography.monoFontFamily};
  font-size: 12px;
  letter-spacing: 0.16em;
  color: ${colors.primary};
  text-transform: uppercase;
`;
